<span nz-icon nzType="question-circle" nzTheme="outline" class="hover" (click)="watch()" *ngIf="!isButton"></span>

<button nz-button *ngIf="isButton" (click)="watch()">
    <span nz-icon nzType="question-circle" nzTheme="outline"></span> HELP
</button>